
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import {
    Alert,
    Grid,
    Stack,
} from '@mui/material';

import TeamsList from '../TeamsList/TeamsListStructure';
import { useNavigate } from 'react-router';
import { axiosFetch } from '../../../../../utils/AxiosFetch';
import Filters from '../Filters/Filters';
import { SnackbarActions } from '../../../../../redux/actions/snackbar.actions';
import { useDispatch } from 'react-redux';
import { useSearchParams } from "react-router-dom";
import { PeriodList } from '../../../../../utils/PeriodList';
import Tab from './Tab';

const ValueAnalysis = () => {

    const isShowAll = true;
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [dateFilter, setDateFilter] = useState("");
    const [teamMembers, setTeamMembers] = useState([]);
    const [employees, setEmployees] = useState([]);
    const [keyword, setKeyword] = useState("");
    const [teamId, setTeamId] = useState("");
    const [departmentId, setDepartmentId] = useState("");
    const [year, setYear] = useState("");



    const handleChangeKeyword = (val) => {
        console.log(val);
        setKeyword(val);
    };

    const handleChangeDateFilter = (val) => {

        setDateFilter(val);
    }

    const handleChangeTeamId = (id) => {
        console.log(id);
        setTeamId(id);
    };

    const handleChangeDepartmentId = (id) => {
        console.log(id);
        setDepartmentId(id);
    };

    const handleChangeYear = (id) => {

        console.log(id);
        setYear(id);
    }



    const handleReviewForm = (id) => {
        navigate(`/form/${id}`);
    };
    const getCurrentSessionDetails = () => {
        const currentYear = new Date().getFullYear();
        const currentMonth = new Date().getMonth() + 1;
        var value = null;
        if (currentMonth <= 6) {
            value = {
                lable: currentYear + "-" + 'H1',
                value: currentYear + "-" + 'H1'
            }

        }
        else {
            value = {
                lable: currentYear + "-" + 'H2',
                value: currentYear + "-" + 'H2'
            }

        }
        var list = PeriodList(3, "half");
        var res = list.filter(list => list.value === value.value)[0];
        setDateFilter(res.label.split('-')[1]);
        setYear(res.label.split('-')[0]);
        return res;


    }



    const loadTeamForm = (param) => {

        var request;
        if (param === 1) {
            request = {
                "Keyword": null,
                "TeamId": null,
                "DepartmentId": null,
                "Year": null,
                "dateFilter": null
            }

        }
        else if (param === 2) {

            var currentSession = getCurrentSessionDetails();
            console.log(currentSession);
            request = {
                "Keyword": null,
                "TeamId": null,
                "DepartmentId": null,
                "Year": currentSession.value.split('-')[0],
                "dateFilter": currentSession.value.split('-')[1]
            }
        }
        else {
            request = {
                "Keyword": keyword !== "" ? keyword : null,
                "TeamId": teamId !== "" ? teamId : null,
                "DepartmentId": departmentId !== "" ? departmentId : null,
                "Year": year !== "" ? year : null,
                "dateFilter": dateFilter !== "" ? dateFilter : null
            }

        }
        axiosFetch({
            method: "post",
            url: `/performance/va/team`,
            requestConfig: request
        })
            // axiosFetch({
            //     method: "post",
            //     url: `/performance/va/team`,
            //     requestConfig: {
            //         year: 2022,
            //         session: 'h2'
            //     }
            // })

            .then((res) => {
                if (res.status === 200) {
                    setEmployees(res.data.employees);
                    setTeamMembers(res.data);
                }
                else if (res.status === 400) {
                    dispatch(SnackbarActions(true, "error", "Something Went Wrong!"));
                }
                else if (res.status === 401) {
                    navigate('/');
                }
            })
            .catch(err =>
                console.error(err)
            )
    }



    useEffect(() => {
        loadTeamForm(2);
    }, [])

    return (
        <div>
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <h1 className="main-heading">Value Analysis</h1>
                    <Filters
                        handleChangeDepartmentId={handleChangeDepartmentId}
                        handleChangeKeyword={handleChangeKeyword}
                        handleChangeTeamId={handleChangeTeamId}
                        handleChangeYear={handleChangeYear}
                        handleChangeDateFilter={handleChangeDateFilter}
                        loadTeamForm={loadTeamForm}


                    />
                </Grid>
                <Tab teamdata={teamMembers} />
                {/* {teamMembers.length === 0 && employees === null ? <Grid item xs={12}><Stack sx={{ width: '100%' }} spacing={2}><Alert severity='error'>No Review History</Alert></Stack></Grid> : ""}
                <Grid item xs={12}>
                    {teamMembers.length !== 0 ? <h1 className='main-heading' style={{ marginBottom: "15px", textDecoration: "auto !important" }}> Team Form(s)</h1> : ""}
                    <TeamsList teamMembers={teamMembers} />
                </Grid>
                <Grid item xs={12}>
                    {employees.length !== 0 ? < h1 className='main-heading' style={{ marginBottom: "15px", textDecoration: "auto !important" }}> Pending Form(s) </h1> : ""}
                    <TeamsList teamMembers={employees} />

                </Grid> */}

            </Grid>

        </div >
    )
}

export default ValueAnalysis;